import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';
import initScrollDirection from './utilities/scroll-direction.js';

import initToggles from './components/toggles';
import initCookies from './components/cookies';
import initVideoEmbeds from './components/video-embeds.js';
import initAudioEmbeds from './components/audio-embeds.js';

import initCarousels from './components/carousels';
import initDarkMode from './components/dark-mode';
import initPersonCards from './components/person-card';
import initShareButtons from './components/share-buttons.js';

import initStoryFilter from './components/story-filter.js';
import initPlacesFilter from './components/places-filter.js';
import initOppsFilter from './components/opps-filter.js';

import initEventForm from './components/event-form.js';
import initDetailForm from './components/detail-form.js';
import initFormMap from './components/form-map.js';
import initFormImage from './components/form-image.js';
import initTinyMce from './components/tiny-mce.js';

initCookies();
initScrollDirection();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const toggleEls = document.querySelectorAll('.js-toggle');

if (toggleEls && toggleEls.length > 0) {
    initToggles(toggleEls);
}

const carouselEls = document.querySelectorAll('.js-carousel');

if (carouselEls && carouselEls.length > 0) {
    initCarousels(carouselEls);
}

const darkModeBtn = document.querySelector('.js-dark-mode');

if (darkModeBtn) {
    initDarkMode(darkModeBtn);
}

const videoEmbeds = document.querySelectorAll('.js-video-embed');

if (videoEmbeds && videoEmbeds.length > 0) {
    initVideoEmbeds(videoEmbeds);
}

const audioPlayers = document.querySelectorAll('.js-audio');

if (audioPlayers && audioPlayers.length > 0) {
    initAudioEmbeds(audioPlayers);
}

const personCards = document.querySelectorAll('.js-person-card');

if (personCards && personCards.length > 0) {
    initPersonCards(personCards);
}

const storyFilter = document.querySelector('.js-story-filter');

if (storyFilter) {
    const filterResults = document.querySelector('.js-filter-results');
    initStoryFilter(storyFilter, filterResults);
}

const placesFilter = document.querySelector('.js-places-filter');

if (placesFilter) {
    initPlacesFilter(placesFilter);
}

const oppsFilter = document.querySelector('.js-opps-filter');

if (oppsFilter) {
    initOppsFilter(oppsFilter);
}

const shareButtons = document.querySelectorAll('.js-share-button');

if (shareButtons && shareButtons.length > 0) {
    initShareButtons(shareButtons);
}

const eventForm = document.querySelector('.js-event-form');

if (eventForm) {
    initEventForm(eventForm);
}
const detailForm = document.querySelector('.js-detail-form');

if (detailForm) {
    initDetailForm(detailForm);
}

const formMap = document.querySelector('.js-map-group');

if (formMap) {
    initFormMap(formMap);
}

const formImageInput = document.querySelector('.js-image-input');

if (formImageInput) {
    initFormImage(formImageInput);
}

const tinyMceEls = document.querySelectorAll('.js-tinymce');

if (tinyMceEls && tinyMceEls.length > 0) {
    initTinyMce(tinyMceEls);
}
